import * as React from "react"
const SvgUndo = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8 19.143a.97.97 0 0 1-.712-.288.97.97 0 0 1-.288-.712q0-.425.288-.713A.97.97 0 0 1 8 17.143h6.1q1.576 0 2.737-1 1.163-1 1.163-2.5c0-1.5-.387-1.834-1.163-2.5q-1.162-1-2.737-1H7.8l1.9 1.9a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-3.6-3.6a.9.9 0 0 1-.212-.325 1.1 1.1 0 0 1-.063-.375q0-.201.063-.375a.9.9 0 0 1 .212-.325l3.6-3.6a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-1.9 1.9h6.3q2.425 0 4.162 1.575T20 13.643q0 2.35-1.738 3.925T14.1 19.143z" />
  </svg>
)
export default SvgUndo
